import React, { useEffect, useState } from "react";
import { getNavBarLinks } from "../../../../lib/getNavBarLinks";
import styles from "./OtherLinks.module.css";

interface NavLink {
  id: number;
  name: string;
  url: string;
}

interface ApiResponse {
  data?: NavLink[];
  [key: string]: any;
}

const MAX_LINKS = 4;

const OtherLinks = () => {
  const [linksData, setLinksData] = useState<NavLink[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const data = await getNavBarLinks();
        if (Array.isArray(data)) {
          setLinksData(data);
        } else if (
          data &&
          typeof data === "object" &&
          Array.isArray((data as ApiResponse).data)
        ) {
          setLinksData((data as ApiResponse).data!);
        } else {
          setError("Invalid data format received");
        }
      } catch (err) {
        setError("Error fetching navbar links");
      } finally {
        setLoading(false);
      }
    };

    fetchLinks();
  }, []);

  // Always render 4 slots to reserve space and avoid CLS
  const renderLinks = () => {
    if (loading) {
      return Array(MAX_LINKS)
        .fill(0)
        .map((_, idx) => (
          <div className={styles.links} key={`skeleton-${idx}`}>
            <span className={styles.linkSkeleton} />
          </div>
        ));
    }
    if (error) {
      return Array(MAX_LINKS)
        .fill(0)
        .map((_, idx) => (
          <div className={styles.links} key={`empty-${idx}`}>
            {/* Empty slot */}
          </div>
        ));
    }
    // Render actual links, pad with empty slots if less than MAX_LINKS
    const paddedLinks = [...linksData].slice(0, MAX_LINKS);
    while (paddedLinks.length < MAX_LINKS) {
      paddedLinks.push(undefined as any);
    }
    return paddedLinks.map((link, idx) =>
      link ? (
        <div className={styles.links} key={link.id || link.url}>
          <a href={link.url} title={link.name}>
            {link.name}
          </a>
        </div>
      ) : (
        <div className={styles.links} key={`empty-${idx}`}></div>
      )
    );
  };

  return <div className={styles.otherLinksContainer}>{renderLinks()}</div>;
};

export default OtherLinks;
